<template>
    <v-container fluid fill-height class="main-container container-fixed d-block">
        <div class="content-block">
            <HeaderMenu :title="listName" class="px-6" :has-notification="hasNewMessages"/>
            <BottomSheet
                v-if="locations && locations.length > 6"
                ref="BottomSheet"
                :activeGroup="activeGroup"
                :locations="locations"
                :offset="hasOffline ? 3 : 2"
                @setRoom="setActiveGroup"
            ></BottomSheet>
            <v-layout row class="locations-group-row" v-dragscroll.x>
                <v-btn
                    v-if="locations && locations.length > 6"
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    :input-value="hasOffline ? activeGroup > 2 : activeGroup > 1"
                    depressed
                    rounded
                    @click="openSheet"
                >
                    {{chosenLocation}}
                    <v-img
                        max-height="20px"
                        max-width="20px"
                        :src="require('@/assets/icons/arrow_down_icon.svg')"
                        class="d-inline-flex ml-2"
                    />
                </v-btn>
                <v-btn
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    v-for="(location, index) in locationsScroll"
                    :key="index"
                    :input-value="activeGroup == index"
                    depressed
                    rounded
                    :id="`location${index}`"
                    @click="setActiveGroup(index)"
                >
                    <v-img
                        v-if="hasOffline && location == 'Неисправные'"
                        width="22px"
                        height="22px"
                        :src="require('@/assets/icons/info_icon.svg')"
                    ></v-img>
                    {{ location }}
                </v-btn>
            </v-layout>
            <v-layout
                id="scroll-target"
                class="devices-list scroll-layout px-6"
                column
                v-if="deviceTypes"
                v-scroll:#scroll-target="onScroll"
            >
                <div v-if="devicesFiltered.length == 0 && activeGroup == 0" class="img-center">
                    <v-flex text-center>
                        <v-img
                            :src="require('@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        ></v-img>
                        <div class="common-text text-center">
                            Вы пока не добавили ни одного <br> устройства в избранное
                        </div>
                    </v-flex>
                </div>
                <div v-else :key="devicesFiltered.length">
                    <div v-for="(device, index) in devicesFiltered" :key="index">
                        <CardholderDevice v-if="device.device_type == 1" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <SwitchDevice v-if="device.device_type == 2" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <MotionSensorDevice v-if="device.device_type == 3" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <OpeningSensorDevice v-if="device.device_type == 4" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <VentilationDevice v-if="device.device_type == 5" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <LeakSensorDevice v-if="device.device_type == 6" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <ThermometerDevice v-if="device.device_type == 7" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <CurtainsDevice v-if="device.device_type == 8" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <LightingDevice v-if="device.device_type == 9" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <SocketDevice v-if="device.device_type == 10" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <FridgeDevice v-if="device.device_type == 11" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <HeatingDevice v-if="device.device_type == 12" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <WarmFloorDevice v-if="device.device_type == 13" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <WaterShutOffDevice v-if="device.device_type == 14" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <DimmableLightingDevice v-if="device.device_type == 15" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <TVDevice v-if="device.device_type == 16" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <IlluminationSensor v-if="device.device_type == 17" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                        <HumidityDevice v-if="device.device_type == 18" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showLocation"/>
                    </div>
                </div>
            </v-layout>
            <ModalOffline ref="modalErrorOffline"></ModalOffline>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка устройств" noCancel></ModalWaiting>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import deviceTypes from '../plugins/deviceTypes.js';
import CardholderDevice from "@/components/devices/CardholderDevice";
import VentilationDevice from "@/components/devices/VentilationDevice";
import ThermometerDevice from "@/components/devices/ThermometerDevice";
import SwitchDevice from "@/components/devices/SwitchDevice";
import MotionSensorDevice from "@/components/devices/MotionSensorDevice";
import OpeningSensorDevice from "@/components/devices/OpeningSensorDevice";
import LeakSensorDevice from "@/components/devices/LeakSensorDevice";
import CurtainsDevice from "@/components/devices/CurtainsDevice";
import IlluminationSensor from "@/components/devices/IlluminationSensor";
import LightingDevice from "@/components/devices/LightingDevice";
import SocketDevice from "@/components/devices/SocketDevice";
import FridgeDevice from "@/components/devices/FridgeDevice";
import HeatingDevice from "@/components/devices/HeatingDevice";
import WarmFloorDevice from "@/components/devices/WarmFloorDevice";
import WaterShutOffDevice from "@/components/devices/WaterShutOffDevice";
import DimmableLightingDevice from "@/components/devices/DimmableLightingDevice";
import TVDevice from "@/components/devices/TVDevice";
import HumidityDevice from "@/components/devices/HumidityDevice";
import BottomSheet from "@/components/BottomSheet";
import {eventBus} from "@/main";
import ModalOffline from "@/components/modals/ModalOffline";
import ModalWaiting from "@/components/modals/ModalWaiting";
import { dragscroll } from 'vue-dragscroll';

export default {
    name: "DeviceList",
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        HeaderMenu,
        CardholderDevice,
        VentilationDevice,
        ThermometerDevice,
        SwitchDevice,
        MotionSensorDevice,
        OpeningSensorDevice,
        LeakSensorDevice,
        CurtainsDevice,
        LightingDevice,
        SocketDevice,
        FridgeDevice,
        HeatingDevice,
        WarmFloorDevice,
        WaterShutOffDevice,
        DimmableLightingDevice,
        TVDevice,
        HumidityDevice,
        ModalOffline,
        IlluminationSensor,
        ModalWaiting,
        BottomSheet,
    },
    data() {
        return {
            hasNewMessages: false,
            activeGroup: 0,
            room: "",
            categories: [ "Избранное",  "Все", ],
            locations: [],
            deviceTypes: deviceTypes,
            devices: [],
            offsetTop: 0,
        };
    },
    created() {
        eventBus.$on("device", this.updateDevice);
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("device", this.updateDevice);
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    computed: {
        listName() {
            return "Управление номером " + this.room;
        },
        devicesFiltered() {
            this.devices.forEach((el) => {
                el.show_favorite = true;
            });
            this.devices = this.devices.sort((a, b) => (a.name > b.name) ? 1 : -1);
            if (this.activeGroup == 0) {
                this.devices.forEach((el) => {
                    el.show_favorite = false;
                });
                return this.devices.filter((el) => { return el.is_favorite == true });
            } else if (this.hasOffline && this.activeGroup == 2) {
                return this.devices.filter((el) => { return !el.online });
            } else if (this.activeGroup > 1) {
                return this.devices.filter((el) => { return el.location == this.locations[this.activeGroup] });
            }
            return this.devices;
        },
        locationsScroll() {
            if (this.locations && this.locations.length < 7) {
                return this.locations;
            }
            return this.categories;
        },
        hasOffline() {
            return this.devices.some((el) => !el.online);
        },
        showLocation() {
            return this.hasOffline ? [0, 1, 2].includes(this.activeGroup) : [0, 1].includes(this.activeGroup);
        },
        chosenLocation() {
            let step = this.hasOffline ? 2 : 1;
            return this.activeGroup > step ? this.locations[this.activeGroup] : "Выберите комнату";
        },
    },
    methods: {
        loadPage() {
            if (this.$route.query.master_key) {
                this.$router.push({name: "master", query: this.$route.query});
            } else if (this.$store.state.accessToken) {
                this.getDevices();
            } else {
                this.$router.push({ name: "empty" });
            }
        },
        getDevices() {
            this.$refs.modalWaiting.open();
            this.locations = [];
            this.scenarios = [];
            this.room = "";
            if (this.categories.length > 2) {
                this.categories.splice(2, 1);
            }
            this.hasNewMessages = false;
            this.$http.get('/devices/guest/devices/')
                .then((response) => {
                    if (!response.data.online) {
                        this.$refs.modalErrorOffline.open();
                    }
                    this.devices = response.data.devices;
                    if (this.devices.filter((el) => { return el.is_favorite == true }).length == 0 && this.activeGroup < 2) {
                        this.activeGroup = 1;
                    }
                    localStorage.RobohotelTZ = response.data.room.hotel.timezone;
                    this.room = response.data.room.name;
                    this.hasNewMessages = response.data.have_unread_messages;
                    if (this.hasOffline) {
                        this.categories.push("Неисправные");
                    }
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    if (response.data.locations) {
                        response.data.locations.forEach((el) => {
                            if (el) {
                                this.locations.push(el);
                            }
                        });
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.code == "access_key_expiration_date_has_expired") {
                        this.$router.push({ name: "final", params: { message: error.response.data.message }});
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if (this.$store.state.storeActiveGroup !== null) {
                            let i = this.locations.indexOf(this.$store.state.storeActiveGroup);
                            if (i !== -1) {
                                this.activeGroup = i;
                                // document.getElementById(`location${this.activeGroup}`).scrollIntoView({inline: "center"});
                            }
                        }
                    });
                    if (this.$refs.modalWaiting) {
                        this.$refs.modalWaiting.close();
                    }
                });
        },
        setFavorite(item) {
            this.$http.put('/hotels/guest/device/favorites/' + item.uid + '/', {
                is_favorite: !item.is_favorite,
            })
                .then(() => {
                    item.is_favorite = !item.is_favorite;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateDevice(data) {
            let deviceChanged = this.devices.filter((el) => { return el.uid == data.device.uid })[0];
            let deviceIndex = this.devices.indexOf(deviceChanged);
            data.disabled = false;
            if (data.device && deviceChanged) {
                data.device.is_favorite = deviceChanged.is_favorite;
            }
            this.$set(this.devices, deviceIndex, data.device);
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
            this.$store.commit('setScroll', this.offsetTop);
        },
        setActiveGroup(index) {
            this.activeGroup = index;
            this.$store.commit("setActiveGroup", this.locations[this.activeGroup]);
        },
        openSheet() {
            this.$refs.BottomSheet.open();
        },
    },
}
</script>

<style lang="scss">
.main-container .devices-list.scroll-layout {
    padding-bottom: 80px;

    .img-center {
        position: relative;
        top: calc(50% - 162px);
    }
}
</style>